import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { RatingsAndReviewsDefaultProps, RatingsAndReviewsPropTypes } from './RatingsAndReviewsPropTypes';
import { RatingsAndReviewsPlaceholder } from './RatingsAndReviewsPlaceholder';
import { dataModel } from './ReviewDataModel';

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./RatingsAndReviewsDesktop')).RatingsAndReviewsDesktop;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "ratings-and-reviews-desktop" */
      './RatingsAndReviewsDesktop');
  },
  name: 'RatingsAndReviewsDesktop',
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'product-section-rr',
  placeholder: (
    <RatingsAndReviewsPlaceholder
      color="#E0E0E0"
      showLoadingAnimation
    />
  ),
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
export const RatingsAndReviewsDesktopImporter = withLayoutGroup({
  name: 'ratings'
}, DynamicComponent);

RatingsAndReviewsDesktopImporter.displayName = 'RatingsAndReviewsDesktopImporter';
RatingsAndReviewsDesktopImporter.propTypes = RatingsAndReviewsPropTypes;

RatingsAndReviewsDesktopImporter.defaultProps = RatingsAndReviewsDefaultProps;
RatingsAndReviewsDesktopImporter.dataModel = dataModel;
